module.exports = __webpack_public_path__ + "static/1_section-Img-a45e73bd1f9f42c93226a40a27695b65.png";